import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts"; // Adjust path if needed

export default function BestSellerSection() {
  const [arrivals, setArrivals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    subtitle: "",
    title: "",
    description: "",
  });

  useEffect(() => {
    fetchArrivals();
  }, []);

  const fetchArrivals = async () => {
    setLoading(true);
    const { data, error } = await supabase.from("best_sellers_section").select("*");
    if (error) setError(error.message);
    else setArrivals(data);
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      subtitle: item.subtitle || "",
      title: item.title || "",
      description: item.description || "",
    });
  };

  const handleCancel = () => {
    setEditingItem(null);
    setFormData({ subtitle: "", title: "", description: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const table = supabase.from("best_sellers_section");

    const { error } = await table
      .update(formData)
      .eq("id", editingItem.id);

    if (error) alert("Update failed: " + error.message);
    else {
      alert("Updated successfully");
      handleCancel();
      fetchArrivals();
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        backgroundColor: "#f8f9fa",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
      }}
    >
      <h2 style={{ marginBottom: 30, color: "#343a40" }}  > Gestionnaire de la Section Meilleures ventes 
</h2>

      {editingItem && (
        <form onSubmit={handleSubmit} style={formStyle}>
          <h3 style={{ width: "100%", color: "#495057" }}>Modification Section</h3>
          <input
            type="text"
            name="subtitle"
            placeholder="Subtitle"
            value={formData.subtitle}
            onChange={handleChange}
            required
            style={inputStyle}
          />
          <input
            type="text"
            name="title"
            placeholder="Title"
            value={formData.title}
            onChange={handleChange}
            required
            style={inputStyle}
          />
          <textarea
            name="description"
            placeholder="Description"
            value={formData.description}
            onChange={handleChange}
            rows={3}
            style={{ width: "100%", fontSize: 16, padding: 10 }}
            required
          />
          <div style={{ display: "flex", gap: 10, marginTop: 10, width: "100%" }}>
            <button type="submit" style={buttonStyle}>Update</button>
            <button type="button" onClick={handleCancel} style={{ ...buttonStyle, backgroundColor: "#6c757d" }}>Cancel</button>
          </div>
        </form>
      )}

      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <p>Loading...</p>}

      <div style={{ display: "flex", flexWrap: "wrap", gap: 24, justifyContent: "center" }}>
        {arrivals.map((item) => (
          <div key={item.id} style={cardStyle}>
            <h5 style={{ color: "#888", marginBottom: 8 }}>{item.subtitle}</h5>
            <h4 style={{ color: "#212529", marginBottom: 8 }}>{item.title}</h4>
            <p>{item.description}</p>
            <button onClick={() => handleEdit(item)} style={{ ...buttonStyle, marginTop: 10, backgroundColor: "rgba(255, 65, 180, 0.8)" }}>
              Edit
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

const formStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: 15,
  maxWidth: 700,
  backgroundColor: "#fff",
  padding: 20,
  borderRadius: 8,
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  marginBottom: 40,
};

const cardStyle = {
  width: 700,
  backgroundColor: "#fff",
  borderRadius: 10,
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  padding: 15,
  textAlign: "center",
  position: "relative",
  minHeight: 200,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between"
};

const inputStyle = {
  flex: "1 1 200px",
  padding: "10px 12px",
  borderRadius: 6,
  border: "1.5px solid #ced4da",
  fontSize: 16,
  outline: "none",
  transition: "border-color 0.3s",
};

const buttonStyle = {
  padding: "10px 18px",
  border: "none",
  borderRadius: 6,
  color: "#fff",
  fontWeight: "600",
  cursor: "pointer",
  flex: 1,
  backgroundColor: "gray",
  transition: "background-color 0.3s",
};
